'use client';

import { Loader2 } from 'lucide-react';

import { cn } from '../utils/cn';

import type { SVGProps } from 'react';

/**
 * Plain spinner using lucide's Loader2 with our animation. Custom (not Radix).
 */
export const Spinner = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <Loader2 className={cn('h-4 w-4 animate-spin', className)} aria-label="Loading" {...props} />
);
